import { render } from "./DeleteModal.vue?vue&type=template&id=51ecf48c&scoped=true&ts=true"
import script from "./DeleteModal.vue?vue&type=script&lang=ts"
export * from "./DeleteModal.vue?vue&type=script&lang=ts"

import "./DeleteModal.vue?vue&type=style&index=0&id=51ecf48c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ecf48c"]])

export default __exports__